import type { QueryKey, UseQueryResult, UseQueryOptions, QueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { GetAboutBannerQueryResponse, GetAboutBanner400, GetAboutBanner404, GetAboutBanner500 } from "../types/GetAboutBanner";

export const getAboutBannerQueryKey = () =>     [{url:`/api/mainPage/aboutBanner`}] as const;
      export function getAboutBannerQueryOptions <TData = GetAboutBannerQueryResponse, TError = GetAboutBanner400 | GetAboutBanner404 | GetAboutBanner500>(options: Partial<Parameters<typeof client>[0]> = {}): UseQueryOptions<TData, TError> {
        const queryKey = getAboutBannerQueryKey();

        return {
          queryKey,
          queryFn: () => {
            
            return client<TData, TError>({
              method: "get",
              url: `/api/mainPage/aboutBanner`,
              
              
              ...options,
            }).then(res => res.data);
          },
        };
      };
      
/**
 * @summary Получение баннера о площадке
 * @link /api/mainPage/aboutBanner
 */

export function useGetAboutBanner <TData = GetAboutBannerQueryResponse, TError = GetAboutBanner400 | GetAboutBanner404 | GetAboutBanner500>(options: {
          query?: UseQueryOptions<TData, TError>,
          client?: Partial<Parameters<typeof client<TData, TError>>[0]>,
        } = {}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const { query: queryOptions, client: clientOptions = {} } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getAboutBannerQueryKey();

  const query = useQuery<TData, TError>({
    ...getAboutBannerQueryOptions<TData, TError>(clientOptions),
    ...queryOptions
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey as QueryKey;

  return query;
};
